"use client";

import { useEffect } from "react";
import { flushAuthToast } from "@/lib/auth-toast";

export default function AuthToastHandler() {
  useEffect(() => {
    flushAuthToast();
  }, []);

  return null;
}
